import { render, staticRenderFns } from "./SiloProfileHistoryChart.vue?vue&type=template&id=4d5244f2&scoped=true&"
import script from "./SiloProfileHistoryChart.vue?vue&type=script&lang=js&"
export * from "./SiloProfileHistoryChart.vue?vue&type=script&lang=js&"
import style0 from "./SiloProfileHistoryChart.vue?vue&type=style&index=0&id=4d5244f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5244f2",
  null
  
)

export default component.exports